<template>
  <h5 v-show="headerProps?.isTitle">{{ headerProps?.title }}</h5>
  <span v-show="headerProps?.isTitle">{{ headerProps?.subtitle }}</span>
  <div class="row">
    <!-- Search -->
    <div class="col-3">
      <z-search
        v-model="searchTerm"
        class="mt-2"
        name="search"
        label=""
        placeholder="Search"
        :readonly="isLoading"
      />
    </div>
    <!-- Filter -->
    <!-- <div class="col-md-4">
        <div class="row mt-2">
          <i class="fas fa-filter col-md-1 filterIcon"></i>
          <dt-select class="col-md-10" v-model="filterBy" :options="filterOptions"></dt-select>
        </div>
      </div> -->
    <!-- Actions -->
    <div class="col-3">
      <div class="row mt-2">
        <div v-if="headerProps?.isAdd">
          <button class="btn btn-primary btn-sm" @click="action('add')">Add</button>
        </div>
        <div v-show="headerProps?.isDelete && headerProps?.isChecked" class="ml-2">
          <button class="btn btn-primary btn-sm" @click="action('delete')">Delete</button>
        </div>
        <div v-if="headerProps?.toggleButtons" class="table-header-toggle-buttons">
          <div v-for="(item, idx) of headerProps?.toggleButtons" :key="idx" class="me-2">
            <input
              v-model="radioChecked"
              :value="item.value"
              :id="`option${idx}`"
              type="radio"
              name="options"
              autocomplete="off"
              class="btn-check"
            />
            <label
              :for="`option${idx}`"
              class="btn"
              :class="{ 'btn-primary': item.checked, 'btn-secondary': !item.checked }"
              >{{ item.name }}</label
            >
          </div>
        </div>
        <div v-if="headerProps?.buttons">
          <button
            v-for="(item, idx) of headerProps?.buttons"
            :key="idx"
            class="btn btn-primary btn-sm"
            @click="action(item.value)"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </div>
    <div class="col">
      <div v-if="headerProps?.isPaginated" class="row">
        <!-- Pagination -->
        <div class="col-2">
          <z-select
            v-model="pageSize"
            :options="headerProps?.pageSizes"
            label=""
            name="pageSize"
            :disabled="isLoading"
            style="min-width: 51px"
          />
        </div>
        <div class="col">
          <nav>
            <z-paginate v-model="page" :page-count="pages" />
          </nav>
        </div>
        <div class="col-2 text-right d-none d-md-block">
          <h5 class="mt-0 me-0" title="# items">{{ numItems }} items</h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ZSearch from './Search.vue'
import ZSelect from './Select.vue'
import ZPaginate from './Paginate.vue'

export default {
  name: 'ZTableHeader',
  components: {
    ZSearch,
    ZSelect,
    ZPaginate
  },
  props: {
    headerProps: {
      pageSizes: [
        { name: '10', value: 10 },
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 }
      ],
      title: null,
      subtitle: null,
      isTitle: false,
      isPaginated: true,
      isChecked: false,
      isAdd: false,
      isDelete: false,
      toggleButtons: null,
      buttons: null
    },
    listParams: {
      page: 0,
      pageSize: 10,
      numItems: 0,
      filterBy: null,
      searchTerm: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['search', 'add', 'delete', 'toggle', 'click', 'updateParams', 'update:listParams'],
  computed: {
    numItems() {
      return this.listParams.numItems
    },
    pages() {
      let num = 0
      if (this.listParams) {
        if (this.listParams.pageSize > 0) {
          num = Math.ceil(this.listParams.numItems / this.listParams.pageSize)
        }
      }
      return num
    },
    page: {
      get() {
        let page = this.listParams.page
        console.log('Page:', page)
        return page
      },
      set(value) {
        this.$emit('updateParams', {
          name: 'page',
          value: value
        })
        this.search(false)
        this.$forceUpdate()
      }
    },
    pageSize: {
      get() {
        return this.listParams.pageSize
      },
      set(value) {
        this.$emit('updateParams', {
          name: 'pageSize',
          value: value
        })
        this.listParams.pageSize = value
        this.page = 1
      }
    },
    filterBy: {
      get() {
        return this.listParams.filterBy
      },
      set(value) {
        this.$emit('updateParams', {
          name: 'filterBy',
          value: value
        })
        //this.listParams.filterBy = value
        this.page = 1
      }
    },
    searchTerm: {
      get() {
        return this.listParams.searchTerm
      },
      set(value) {
        this.$emit('updateParams', {
          name: 'searchTerm',
          value: value
        })
        this.listParams.searchTerm = value.trim()
        this.search(true)
      }
    },
    radioChecked: {
      get() {
        let _data = 0
        if (this.headerProps.toggleButtons) {
          let found = this.headerProps.toggleButtons.find((x) => x.checked)
          if (found) {
            _data = found.value
          }
        }
        return _data
      },
      set(value) {
        this.$forceUpdate()
        this.action('toggle', value)
      }
    }
  },
  methods: {
    search(resetPage) {
      this.$emit('search', {
        search: this.listParams.searchTerm,
        reset: resetPage
      })
    },
    action(name, value) {
      this.$emit(name, value)
    }
  }
}
</script>
<style scoped>
.filterIcon {
  top: 8px;
  font-size: 1.2em;
}
.filterListing {
  float: left;
}
.custom-items {
  right: 10px;
  top: -10px;
  position: relative;
}
.table-header-toggle-buttons {
  display: inline-flex;
}
</style>
